// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-transparent {
  color: transparent !important;
}

.text-align-right {
  text-align: right;
}

.div-border {
  border: 1px solid lightgrey;
}

.div-border-left {
  border-left: 1px solid lightgrey;
}

.div-border-top {
  border-top: 1px solid lightgrey;
}

.div-border-left-top {
  border-left: 1px solid lightgrey;
  border-top: 1px solid lightgrey;
}

.div-border-left-top-right {
  border-left: 1px solid lightgrey;
  border-top: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
}

.div-border-all {
  border-left: 1px solid lightgrey;
  border-top: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-left-right {
  border-left: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
}

.div-border-right {
  border-right: 1px solid lightgrey;
}

.div-border-top-right {
  border-top: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
}

.div-border-right-bottom {
  border-right: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-top-right-bottom {
  border-top: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom {
  border-bottom: 1px solid lightgrey;
}

.div-border-top-bottom {
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom-left {
  border-left: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom-left-right {
  border-right: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom-left-top {
  border-top: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom-left-top-right {
  border: 1px solid lightgrey;
}

.div-text-center {
  text-align: center;
}

.borderless {
  border: 0;
}

::ng-deep p-dialog#product-list-dialog .p-component-overlay .p-dialog {
  border-radius: 1.2rem;
  overflow: hidden;
}

::ng-deep table.table-quotation-lines th, table.table-quotation-lines th {
  padding: 0.25rem !important;
  font-size: smaller;
  border-width: 1px !important;
}
::ng-deep table.table-quotation-lines th.category, table.table-quotation-lines th.category {
  width: 5%;
}
::ng-deep table.table-quotation-lines th.qty, table.table-quotation-lines th.qty {
  width: 5%;
  text-align: center;
}
::ng-deep table.table-quotation-lines th.amount, table.table-quotation-lines th.amount {
  width: 8.5%;
  text-align: center;
}
::ng-deep table.table-quotation-lines th.action, table.table-quotation-lines th.action {
  width: 60px;
  text-align: center;
}
::ng-deep table.table-quotation-lines th:first-child .fixed-left-dynamic-right, table.table-quotation-lines th:first-child .fixed-left-dynamic-right {
  display: flex;
  width: 100%;
  height: 100%;
}
::ng-deep table.table-quotation-lines th:first-child .fixed-left-dynamic-right .fixed-left, table.table-quotation-lines th:first-child .fixed-left-dynamic-right .fixed-left {
  width: 60px;
  flex-shrink: 0; /* Prevents shrinking */
  overflow: hidden; /* Handles content overflow */
}
::ng-deep table.table-quotation-lines th:first-child .fixed-left-dynamic-right .dynamic-right, table.table-quotation-lines th:first-child .fixed-left-dynamic-right .dynamic-right {
  flex-grow: 1; /* Takes remaining space */
  overflow: hidden; /* Handles content overflow */
  display: flex; /* Add flexbox for vertical centering */
  align-items: center; /* Vertically center content */
}
::ng-deep table.table-quotation-lines td, table.table-quotation-lines td {
  padding: 0.65rem 0.5rem !important;
  font-size: smaller;
}
::ng-deep table.table-quotation-lines td a, table.table-quotation-lines td a {
  color: var(--primary-color) !important;
  text-decoration: none;
}
::ng-deep table.table-quotation-lines td a.font-large, table.table-quotation-lines td a.font-large {
  font-size: large !important;
}
::ng-deep table.table-quotation-lines td a.font-x-large, table.table-quotation-lines td a.font-x-large {
  font-size: x-large !important;
}
::ng-deep table.table-quotation-lines td a.font-xx-large, table.table-quotation-lines td a.font-xx-large {
  font-size: xx-large !important;
}
::ng-deep table.table-quotation-lines td a:hover, table.table-quotation-lines td a:hover {
  color: var(--primary-light) !important;
  text-decoration: underline !important;
}
::ng-deep table.table-quotation-lines td a:visited, table.table-quotation-lines td a:visited {
  color: var(--primary-color) !important;
}
::ng-deep table.table-quotation-lines td a.font-red, table.table-quotation-lines td a.font-red {
  color: red !important;
}
::ng-deep table.table-quotation-lines td a.font-red:hover, table.table-quotation-lines td a.font-red:hover {
  color: darkred !important;
  text-decoration: underline !important;
}
::ng-deep table.table-quotation-lines td a.font-red:visited, table.table-quotation-lines td a.font-red:visited {
  color: red !important;
}
::ng-deep table.table-quotation-lines td.category, table.table-quotation-lines td.category {
  width: 5%;
}
::ng-deep table.table-quotation-lines td.qty, table.table-quotation-lines td.qty {
  width: 5%;
  text-align: right;
}
::ng-deep table.table-quotation-lines td.amount, table.table-quotation-lines td.amount {
  width: 8.5%;
  text-align: right;
}
::ng-deep table.table-quotation-lines td.action, table.table-quotation-lines td.action {
  width: 60px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/secure/dashboard/rfqs/quotation/quotation.component.scss"],"names":[],"mappings":"AAAA;EACC,6BAAA;AACD;;AAEA;EACC,iBAAA;AACD;;AAEA;EACC,2BAAA;AACD;;AAEA;EACC,gCAAA;AACD;;AAEA;EACC,+BAAA;AACD;;AAEA;EACC,gCAAA;EACA,+BAAA;AACD;;AAEA;EACC,gCAAA;EACA,+BAAA;EACA,iCAAA;AACD;;AAEA;EACC,gCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;AACD;;AAEA;EACC,gCAAA;EACA,iCAAA;AACD;;AAEA;EACC,iCAAA;AACD;;AAEA;EACC,+BAAA;EACA,iCAAA;AACD;;AAEA;EACC,iCAAA;EACA,kCAAA;AACD;;AAEA;EACC,+BAAA;EACA,iCAAA;EACA,kCAAA;AACD;;AAEA;EACC,kCAAA;AACD;;AAEA;EACC,+BAAA;EACA,kCAAA;AACD;;AAEA;EACC,gCAAA;EACA,kCAAA;AACD;;AAEA;EACC,iCAAA;EACA,gCAAA;EACA,kCAAA;AACD;;AAEA;EACC,+BAAA;EACA,gCAAA;EACA,kCAAA;AACD;;AAEA;EACC,2BAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,SAAA;AACD;;AAKG;EACC,qBAAA;EACA,gBAAA;AAFJ;;AAUE;EACC,2BAAA;EACA,kBAAA;EACA,4BAAA;AAPH;AASG;EACC,SAAA;AAPJ;AASG;EACC,SAAA;EACA,kBAAA;AAPJ;AASG;EACC,WAAA;EACA,kBAAA;AAPJ;AASG;EACC,WAAA;EACA,kBAAA;AAPJ;AAWI;EACC,aAAA;EACA,WAAA;EACA,YAAA;AATL;AAYI;EACC,WAAA;EACA,cAAA,EAAA,uBAAA;EACA,gBAAA,EAAA,6BAAA;AAVL;AAaI;EACC,YAAA,EAAA,0BAAA;EACA,gBAAA,EAAA,6BAAA;EACA,aAAA,EAAA,uCAAA;EACA,mBAAA,EAAA,8BAAA;AAXL;AAgBE;EACC,kCAAA;EACA,kBAAA;AAdH;AAgBG;EACC,sCAAA;EACA,qBAAA;AAdJ;AAgBI;EAAe,2BAAA;AAbnB;AAcI;EAAiB,6BAAA;AAXrB;AAYI;EAAkB,8BAAA;AATtB;AAWI;EACC,sCAAA;EACA,qCAAA;AATL;AAWI;EACC,sCAAA;AATL;AAYI;EACC,qBAAA;AAVL;AAYK;EACC,yBAAA;EACA,qCAAA;AAVN;AAYK;EACC,qBAAA;AAVN;AAeG;EACC,SAAA;AAbJ;AAeG;EACC,SAAA;EACA,iBAAA;AAbJ;AAeG;EACC,WAAA;EACA,iBAAA;AAbJ;AAeG;EACC,WAAA;EACA,kBAAA;AAbJ","sourcesContent":[".text-transparent {\n\tcolor: transparent !important;\n}\n\n.text-align-right {\n\ttext-align: right;\n}\n\n.div-border {\n\tborder: 1px solid lightgrey;\n}\n\n.div-border-left {\n\tborder-left: 1px solid lightgrey;\n}\n\n.div-border-top {\n\tborder-top: 1px solid lightgrey;\n}\n\n.div-border-left-top {\n\tborder-left: 1px solid lightgrey;\n\tborder-top: 1px solid lightgrey;\n}\n\n.div-border-left-top-right {\n\tborder-left: 1px solid lightgrey;\n\tborder-top: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n}\n\n.div-border-all {\n\tborder-left: 1px solid lightgrey;\n\tborder-top: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-left-right {\n\tborder-left: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n}\n\n.div-border-right {\n\tborder-right: 1px solid lightgrey;\n}\n\n.div-border-top-right {\n\tborder-top: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n}\n\n.div-border-right-bottom {\n\tborder-right: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-top-right-bottom {\n\tborder-top: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom {\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-top-bottom {\n\tborder-top: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom-left {\n\tborder-left: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom-left-right {\n\tborder-right: 1px solid lightgrey;\n\tborder-left: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom-left-top {\n\tborder-top: 1px solid lightgrey;\n\tborder-left: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom-left-top-right {\n\tborder: 1px solid lightgrey;\n}\n\n.div-text-center {\n\ttext-align: center;\n}\n\n.borderless {\n\tborder: 0;\n}\n\n::ng-deep {\n\tp-dialog#product-list-dialog {\n\t\t.p-component-overlay {\n\t\t\t.p-dialog {\n\t\t\t\tborder-radius: 1.2rem;\n\t\t\t\toverflow: hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n::ng-deep table, table {\n\t&.table-quotation-lines {\n\t\tth {\n\t\t\tpadding: 0.25rem !important;\n\t\t\tfont-size: smaller;\n\t\t\tborder-width: 1px !important;\n\n\t\t\t&.category {\n\t\t\t\twidth: 5%;\n\t\t\t}\n\t\t\t&.qty {\n\t\t\t\twidth: 5%;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\t\t\t&.amount {\n\t\t\t\twidth: 8.5%;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\t\t\t&.action {\n\t\t\t\twidth: 60px;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\n\t\t\t&:first-child {\n\t\t\t\t.fixed-left-dynamic-right {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t}\n\n\t\t\t\t.fixed-left-dynamic-right .fixed-left {\n\t\t\t\t\twidth: 60px;\n\t\t\t\t\tflex-shrink: 0; /* Prevents shrinking */\n\t\t\t\t\toverflow: hidden; /* Handles content overflow */\n\t\t\t\t}\n\n\t\t\t\t.fixed-left-dynamic-right .dynamic-right {\n\t\t\t\t\tflex-grow: 1; /* Takes remaining space */\n\t\t\t\t\toverflow: hidden; /* Handles content overflow */\n\t\t\t\t\tdisplay: flex; /* Add flexbox for vertical centering */\n\t\t\t\t\talign-items: center; /* Vertically center content */\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\ttd {\n\t\t\tpadding: 0.65rem 0.5rem !important;\n\t\t\tfont-size: smaller;\n\n\t\t\ta {\n\t\t\t\tcolor: var(--primary-color) !important;\n\t\t\t\ttext-decoration: none;\n\n\t\t\t\t&.font-large { font-size: large !important; }\n\t\t\t\t&.font-x-large { font-size: x-large !important; }\n\t\t\t\t&.font-xx-large { font-size: xx-large !important; }\n\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: var(--primary-light) !important;\n\t\t\t\t\ttext-decoration: underline !important;\n\t\t\t\t}\n\t\t\t\t&:visited {\n\t\t\t\t\tcolor: var(--primary-color) !important;\n\t\t\t\t}\n\n\t\t\t\t&.font-red {\n\t\t\t\t\tcolor: red !important;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: darkred !important;\n\t\t\t\t\t\ttext-decoration: underline !important;\n\t\t\t\t\t}\n\t\t\t\t\t&:visited {\n\t\t\t\t\t\tcolor: red !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.category {\n\t\t\t\twidth: 5%;\n\t\t\t}\n\t\t\t&.qty {\n\t\t\t\twidth: 5%;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t\t&.amount {\n\t\t\t\twidth: 8.5%;\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t\t&.action {\n\t\t\t\twidth: 60px;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
